import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, input, model } from "@angular/core";

import { L3vpnSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { TabbedDetailBase } from "../tabbed-detail-container/tabbed-detail-base";
import { descriptionForEntity } from "../tabbed-detail-container/tabbed-detail-container.helpers";
import { L3vpnFirewallInterconnectPanel } from "./components/l3vpn-firewall-interconnect-panel/l3vpn-firewall-interconnect-panel";
import { L3vpnSapPanel } from "./components/l3vpn-sap-panel/l3vpn-sap-panel";
import { transformL3vpnSap } from "./l3vpn-sap";

@Component({
  selector: "l3vpn-detail-container",
  templateUrl: "l3vpn-detail-container.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [L3vpnFirewallInterconnectPanel, L3vpnSapPanel, TabbedDetailBase, TranslatePipe],
})
export class L3vpnDetailContainer {
  private translate = inject(TranslateService);

  subscription = input.required<L3vpnSubscriptionDetails>();

  protected activeTabIndex = model(0);

  protected transformedSaps = computed(() => this.subscription().l3vpnsapss.map(transformL3vpnSap));

  protected navTabs = computed(() => {
    const s = this.subscription();
    const fwTabs = s.firewallInterconnects.map((fw) => ({
      title: this.translate.instant("ServiceElement.FirewallInterconnect"),
      subtitle: descriptionForEntity(fw),
    }));
    const sapTabs = this.transformedSaps().map((sap) => {
      const base = sap.port?.customer?.fullname ?? "-";
      const subtitle =
        sap.vlanrange?.length ?
          `${base}, ${this.translate.instant("ServiceElement.VLAN")} ${sap.vlanrange}`
        : `${base}, ${this.translate.instant("Subscription.UntaggedPort")}`;
      return { title: descriptionForEntity(sap.port), subtitle };
    });
    return [...fwTabs, ...sapTabs];
  });

  protected activeFirewallInterconnect = computed(() => {
    const idx = this.activeTabIndex();
    const fw = this.subscription().firewallInterconnects;
    return idx < fw.length ? fw[idx] : null;
  });

  protected activeSap = computed(() => {
    const s = this.subscription();
    const idx = this.activeTabIndex() - s.firewallInterconnects.length;
    const saps = this.transformedSaps();
    return idx >= 0 && idx < saps.length ? saps[idx] : null;
  });
}
